import { useMemo } from 'react';
import { motion } from 'motion/react';
import { hashSubmissionId } from './disposal';

const COLORS = ['#FF6B3D', '#F5B942', '#FFFFFF', '#FF8A4A', '#FFF3C4'];

export function WinnerConfetti({
  submissionId,
  active,
}: {
  submissionId: string;
  active: boolean;
}) {
  const pieces = useMemo(() => {
    return Array.from({ length: 14 }, (_, index) => {
      const hash = hashSubmissionId(`${submissionId}:${index}`);
      const angle = ((hash % 360) * Math.PI) / 180;
      const dist = 70 + (hash % 90);
      return {
        x: Math.cos(angle) * dist,
        y: Math.sin(angle) * dist - 40,
        rotate: (hash >>> 8) % 360,
        color: COLORS[hash % COLORS.length],
        delay: (hash % 120) / 1000,
        size: 6 + (hash % 6),
      };
    });
  }, [submissionId]);

  if (!active) return null;

  return (
    <div className="pointer-events-none absolute inset-0 z-20 overflow-visible">
      {pieces.map((piece, index) => (
        <motion.span
          key={index}
          className="absolute left-1/2 top-1/2 rounded-[1px]"
          style={{
            width: piece.size,
            height: piece.size * 0.45,
            background: piece.color,
            marginLeft: -piece.size / 2,
            marginTop: -piece.size / 4,
          }}
          initial={{ x: 0, y: 0, opacity: 1, scale: 0.4, rotate: 0 }}
          animate={{
            x: piece.x,
            y: piece.y,
            opacity: [1, 1, 0],
            scale: 1,
            rotate: piece.rotate,
          }}
          transition={{
            duration: 1.15,
            delay: piece.delay,
            ease: 'easeOut',
          }}
        />
      ))}
    </div>
  );
}
